import { Injectable } from '@angular/core';
import { Notification } from '../api/models/notifications.model';

const STORAGE_KEY_PREFIX = 'readAnnouncements_';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {
  private announcements: Notification[] = [];

  setAnnouncements(announcements: Notification[]): void {
    this.announcements = Array.isArray(announcements)
      ? [...announcements].sort((a, b) => {
        const tb = typeof (b as any).StartTime === 'number'
          ? (b as any).StartTime
          : new Date(b.StartTime as any).getTime();
        const ta = typeof (a as any).StartTime === 'number'
          ? (a as any).StartTime
          : new Date(a.StartTime as any).getTime();
        // Reverse chronological (newest first)
        return tb - ta;
      })
      : [];
  }

  get hasAnnouncements(): boolean {
    return this.announcements.length > 0;
  }

  getReadIds(userId: string): string[] {
    if (!userId) return [];
    const stored = localStorage.getItem(STORAGE_KEY_PREFIX + userId);
    try {
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  }

  private saveReadIds(userId: string, ids: string[]): void {
    localStorage.setItem(STORAGE_KEY_PREFIX + userId, JSON.stringify(ids));
  }

  calculateUnreadCount(userId: string): number {
    if (!this.announcements) return 0;
    const readIds = this.getReadIds(userId);
    return this.announcements.filter(a => !readIds.includes(a.Id)).length;
  }

  markAsRead(userId: string, announcementId: string): void {
    const readIds = this.getReadIds(userId);
    if (!readIds.includes(announcementId)) {
      readIds.push(announcementId);
      this.saveReadIds(userId, readIds);
    }
  }

  markAllAsRead(userId: string): void {
    if (!this.announcements) return;
    const allIds = this.announcements.map(a => a.Id);
    this.saveReadIds(userId, allIds);
  }

  getAll(): Notification[] {
    return this.announcements ? [...this.announcements] : [];
  }
}
